import { FC, Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { enableMapSet } from 'immer';

import { initializeFabric } from '@app/widgets/canvas/utils/initializeFabric';

import { store } from '@app/store';
import { TooltipProvider } from '@app/shared/ui/tooltip';
import { ToastProvider } from '@app/hooks/use-toast-provider';
import { Toaster } from '@app/shared/ui/sonner';
import { router } from '@app/app/router';

import ErrorBoundary from './common/errorBoundary';

import { LoadingScreen } from './components/template';

enableMapSet();

// Инициализируем Fabric.js при запуске приложения
initializeFabric();

export default function app() {
  const container = document.getElementById('root')!;
  const root = createRoot(container);
  root.render(<App />);
}

const App: FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingScreen />}>
        <Provider store={store}>
          <TooltipProvider>
            <ToastProvider>
              <RouterProvider
                router={router()}
                future={{
                  v7_startTransition: true,
                }}
              />
            </ToastProvider>
          </TooltipProvider>
          <Toaster />
        </Provider>
      </Suspense>
    </ErrorBoundary>
  );
};
